module.exports = __webpack_public_path__ + "img/adbl.87ce88c4.png";